import { render, staticRenderFns } from "./Tableau.vue?vue&type=template&id=1010dcf6&scoped=true"
import script from "./Tableau.vue?vue&type=script&lang=js"
export * from "./Tableau.vue?vue&type=script&lang=js"
import style0 from "./Tableau.vue?vue&type=style&index=0&id=1010dcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010dcf6",
  null
  
)

export default component.exports